import Vue from 'vue'
import moment from 'moment'
import numformat from '@/assets/js/accounting.min.js'

Vue.filter('moment', function (date, format) {
  if (date) {
    return moment(date).format(format)
  } else {
    return '-'
  }
})

Vue.filter('numformat', function (value, prefix, x) {
  return numformat.formatMoney(value, prefix, x, '.', ',')
})

Vue.filter('uppercase', function (value) {
  if (value) {
    return value.toString().toUpperCase()
  } else {
    return '-'
  }
})



// WEBPACK FOOTER //
// ./src/filters.js